import React, { useContext } from 'react';
import './PrivacyPolicy.css';
import { ShopContext } from '../../../contexts/ShopContext';

const ShippingPolicy = () => {
  const { shop } = useContext(ShopContext);
  return (
    <div className="contents">
      <div className="contents-wrapper">
        <div className="section-gap">
          <h1>Shipping Policy</h1>
          <h3>Delivery Time:</h3>
          <div style={{ marginTop: 10 }}>
            We deliver freshly prepared food within 30 minutes to 2 hours, depending on your location. Ensure accurate
            delivery details and availability to receive your order.
          </div>
        </div>
        <h3>Contact us:</h3>
        <div style={{ marginTop: 10 }}>
          <strong>Email:</strong> {shop?.config?.email}
        </div>
        <div style={{ marginTop: 10 }}>
          <strong>Mobile:</strong> {shop?.config?.mobile_no ?? shop?.mobile_no}
        </div>
        <div style={{ marginTop: 10, display: 'flex' }}>
          <strong>Address:</strong>
          <div style={{ marginLeft: 10 }}>
            {shop?.config?.address?.split(',').map((i) => (
              <div>{i}</div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ShippingPolicy;
